import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import EntityInformationsForm from 'components/entities/EntityView/EntityInformationsForm';
import BasePage from 'components/UI/BasePage';
import { useGetEntitiesQuery } from 'services/entities/api';
import links from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const EntityUpsertPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { entityId } = useParams<{ entityId: string; }>();
  const { data: entities } = useGetEntitiesQuery();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  const entity = entities && entities.find(e => e.id === entityId);
  // const item = items && items.find(i => i.id === id);

  return (
    <>
      <Helmet>
        <title>{t('createAnEntity')}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.paths.entities, navigate), label: t('entities') },
            { label: t('createAnEntity') },
          ]}
        />
        <h4>{t('createAnEntity')}</h4>
        <EntityInformationsForm
          entity={entity}
        />
      </BasePage>
    </>
  );
};

export default EntityUpsertPage;
